import { api } from "constants/RotasAPI";
import { useAgendamentoContatoContext } from "context/gestaoCobranca/AgendamentoContatoContext";
import usePost from "hooks/usePost";
import { toast } from "react-hot-toast";
import { queryClient } from "shared/util/queryClient";
import { AgendamentoContatoDTO } from "types/dto/AgendamentoContatoDTO";

export const usePostAgendarContato = () => {
  const { isEdicao } = useAgendamentoContatoContext();

  const onSuccess = () => {
    queryClient.invalidateQueries(["agendamentos-contatos"]);
    queryClient.invalidateQueries(["informacoes-agendamento"]);
    queryClient.invalidateQueries(["agendamento-contato-edicao-visualizacao"]);
    let mensagem = isEdicao ? "Agendamento editado com sucesso." : "Agendamento salvo com sucesso.";
    toast.success(mensagem);
  };

  return usePost<AgendamentoContatoDTO>({
    url: api.agendamentoContato.postAgendarContato,
    onSuccess,
  });
};
